import {DemonstrationAgenda, EvaluationSubCriteriaDirectus} from '@frontend/directus';
import {EvaluationDataResponse} from '@frontend/shared-api';
import {
  EnrichedEvaluationDataResponse,
  EvaluationAgendaItemVm,
} from '../../pages/customer/project-sequence/chapter/chapter-7-rfd/step-7-5-provider-evaluation/evaluation-models';

export interface BuildEnrichedRfdEvaluationDataOptions {
  criteriaDirectusId?: string;
}

export function buildEnrichedRfdEvaluationData(
  evaluationDataResponse: EvaluationDataResponse,
  allSubcriteria: EvaluationSubCriteriaDirectus[],
  agenda: DemonstrationAgenda[],
  options: BuildEnrichedRfdEvaluationDataOptions = {},
): EnrichedEvaluationDataResponse {
  const agendaByDirectusId = new Map(agenda.map((item) => [item.id, item]));
  const agendaItems: EvaluationAgendaItemVm[] = (evaluationDataResponse.agendaItems ?? [])
    .filter(
      (item) =>
        item.id != null &&
        item.demonstrationAgendaDirectusId != null &&
        item.orderNumber != null &&
        item.duration != null,
    )
    .filter((item) => {
      const directusItem = agendaByDirectusId.get(item.demonstrationAgendaDirectusId!);
      return directusItem?.display_without_usecases !== true;
    })
    .map((item) => {
      const directusItem = agendaByDirectusId.get(item.demonstrationAgendaDirectusId!);
      return {
        id: item.id!,
        demonstrationAgendaDirectusId: item.demonstrationAgendaDirectusId!,
        orderNumber: item.orderNumber!,
        duration: item.duration!,
        translations: directusItem?.translations ?? [],
      };
    });

  const savedSubcriteria = evaluationDataResponse.subcriteria ?? [];
  const subcriteriaIds = new Set(
    savedSubcriteria.map((subcriteria) => subcriteria.directusId).filter(Boolean) as string[],
  );
  const subcriteriaWeightById = new Map(
    savedSubcriteria
      .map((subcriteria) => [subcriteria.directusId, subcriteria.weight] as const)
      .filter(([directusId]) => Boolean(directusId)) as [string, number | null][],
  );

  let subcriteria = allSubcriteria
    .filter((item) => subcriteriaIds.has(item.id))
    .map((item) => ({
      ...item,
      weight: subcriteriaWeightById.get(item.id) ?? null,
    }));

  if (options.criteriaDirectusId) {
    subcriteria = subcriteria.filter((item) => item.criteria === options.criteriaDirectusId);
  }

  return {
    ...evaluationDataResponse,
    agendaItems,
    subcriteria,
  };
}
